// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__1o9JO","label":"Slider_label__17xqG","container":"Slider_container__CfsJP","slider":"Slider_slider__DIz8N","rangeValue":"Slider_rangeValue__1YJXE"};